import { AuditLevels, AuditCodes } from '@app/data/dtos/audit/audit.dto';
import { appVersion } from '@app/shared/utils/utils';

export class AuditMessage {
  app_version = appVersion;
  level!: AuditLevels;
  message!: string;
  status_code?: AuditCodes;
  date = new Date().toLocaleString();
  app_type = 'WEBAPP';
  app_component = 'UNDEFINED';
  extra = navigator.userAgent;
}
